import type { OrderStatus } from './types.ts';

export const ORDER_STATUSES: readonly OrderStatus[] = [
  'pending_payment',
  'paid',
  'processing',
  'shipped',
  'completed',
  'cancelled',
  'refunded',
];

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  pending_payment: 'Awaiting e-Transfer',
  paid: 'Paid',
  processing: 'Processing',
  shipped: 'Shipped',
  completed: 'Completed',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

/** Allowed moves. Anything not listed is refused by the API and hidden in the admin. */
const TRANSITIONS: Record<OrderStatus, readonly OrderStatus[]> = {
  pending_payment: ['paid', 'cancelled'],
  paid: ['processing', 'shipped', 'cancelled', 'refunded'],
  processing: ['shipped', 'cancelled', 'refunded'],
  shipped: ['completed', 'refunded'],
  completed: ['refunded'],
  cancelled: [],
  refunded: [],
};

export function canTransition(from: OrderStatus, to: OrderStatus): boolean {
  return TRANSITIONS[from].includes(to);
}

export function nextStatuses(from: OrderStatus): readonly OrderStatus[] {
  return TRANSITIONS[from];
}

/** Statuses where the cartons are still reserved against stock. */
export function holdsStock(status: OrderStatus): boolean {
  return status !== 'cancelled' && status !== 'refunded';
}

/** The WooCommerce statuses in the export mapped onto ours. */
export function fromWooStatus(woo: string): OrderStatus {
  switch (woo.replace(/^wc-/, '')) {
    case 'on-hold':
    case 'pending':
      return 'pending_payment';
    case 'processing':
      return 'paid';
    case 'completed':
      return 'completed';
    case 'refunded':
      return 'refunded';
    case 'cancelled':
    case 'failed':
    case 'trash':
    case 'checkout-draft':
      return 'cancelled';
    default:
      throw new Error(`unknown WooCommerce status ${woo}`);
  }
}

/** "Order #1234": what the customer writes in the e-Transfer message. */
export function orderReference(number: number): string {
  return `Order #${number}`;
}
